import { ObjectKeys } from './objectKeys';

/**
A strongly-typed version of `Object.entries()`.

Stay alert and use it with caution! [See more in explanation]
This is useful since `Object.entries()` always returns an array of `Array<[string, T]>`. 

Short explanation:
It makes sense only in the domain of type variables (i.e. T and keyof T). Once you move to the instantiated type world 
it degenerates because an object can (and often does) have more properties at run-time than are statically known at compile time

- [Explanation](https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208)
- [TypeScript issues about this](https://github.com/microsoft/TypeScript/pull/12253)

@example
```
const typedEntries = objectEntries({a: 1, b: 2, c: 3}); //=> Array<['a' | 'b' | 'c', number]>
const untypedEntries = Object.entries({a: 1, b: 2, c: 3}); //=> Array<[string, number]>
```
*/

export const objectEntries = Object.entries as <T extends Record<PropertyKey, unknown>>(
  value: T
) => Array<[ObjectKeys<T>, T[ObjectKeys<T>]]>;
